import { fetchGet } from './api';
import { ITaxon } from '../types/taxon.type';

export const fetchTaxons = () => fetchGet<ITaxon[]>('taxons');
